import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import usePincodeLookup from '../../../hooks/usePincodeLookup';

const Section = styled.div`
  padding: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  margin-top: 30px;
`;

const Title = styled.h2`
  background-color: #f28c28;
  color: white;
  padding: 12px 20px;
  margin: -20px -20px 20px;
  font-size: 18px;
`;

const FormRow = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  margin-bottom: 20px;
`;

const FormGroup = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  font-weight: bold;

  span {
    color: red;
    margin-left: 3px;
  }
`;

const Input = styled.input`
  padding: 10px;
  border: 1px solid ${({ error }) => (error ? 'red' : '#ccc')};
  border-radius: 4px;
  margin-top: 5px;
`;

const RadioGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  margin-top: 8px;
`;

const ErrorText = styled.span`
  color: red;
  font-size: 12px;
  margin-top: 5px;
`;

const Button = styled.button`
  margin-top: 10px;
  padding: 10px 25px;
  background-color: #f28c28;
  color: white;
  border: none;
  border-radius: 4px;
  font-weight: bold;
  cursor: pointer;
`;

const ButtonBack = styled.button`
  margin-top: 10px;
  margin-right: 10px;
  padding: 10px 25px;
  background-color: rgb(240, 40, 40);
  color: white;
  border: none;
  border-radius: 4px;
  font-weight: bold;
  cursor: pointer;
`;

const ProposerDetails = ({
  values,
  setValues,
  septateCombinedRedux,
  enquiryId,
  errors,
  isFetching,
  success,
  onContinue,
  onBack,
}) => {
useEffect(() => {
  const self = septateCombinedRedux?.insuredMembers?.self;
  const userDetails = septateCombinedRedux?.userDetail;

  if (self && userDetails) {
    setValues((prevValues) => ({
      ...prevValues,
      firstName: self.firstName || '',
      lastName: self.lastName || '',
      dob: self.dob || '',
      gender: self.gender || '',
      mobile: userDetails.phone || '',
      email: userDetails.email || '',
      address1: self.address1 || '',
      address2: self.address2 || '',
      city: userDetails.city || '',
      state: userDetails.state || '',
      pincode: userDetails.pinCode || '',
      pan: userDetails.panNo || '',
      NomineeName: self.NomineeName || '',
      nomineeContact: self.nomineeContact || '',
      NomineeRelation: self.NomineeRelation || '',
      NomineeDob: self.NomineeDob || '',
      nomineeAddress: self.nomineeAddress || '',
    }));
  }
}, [
  JSON.stringify(septateCombinedRedux?.insuredMembers?.self),
  JSON.stringify(septateCombinedRedux?.userDetail),
]);


  const handleSetCity = (city) => {
    setValues((prev) => ({ ...prev, city }));
  };

  const handleSetState = (state) => {
    setValues((prev) => ({ ...prev, state }));
  };

  const handleSetPincodeOptions = (options) => {
    setValues((prev) => ({ ...prev, pincodeOptions: options }));
  };

  const { loading } = usePincodeLookup({
    pincode: values.pincode,
    onSetCity: handleSetCity,
    onSetState: handleSetState,
    onSetOptions: handleSetPincodeOptions,
  });

  return (
    <Section>
      <Title>Proposer Details</Title>

      <FormRow>
        <FormGroup>
          <Label>
            First Name<span>*</span>
          </Label>
          <Input value={values.firstName} disabled />
        </FormGroup>

        <FormGroup>
          <Label>
            Last Name<span>*</span>
          </Label>
          <Input value={values.lastName} disabled />
        </FormGroup>

        <FormGroup>
          <Label>
            Date of Birth<span>*</span>
          </Label>
          <Input value={values.dob} disabled />
        </FormGroup>
      </FormRow>

      <FormRow>
        <FormGroup>
          <Label>
            Gender<span>*</span>
          </Label>
          <RadioGroup>
            <label>
              <input
                type="radio"
                name="gender"
                value="Male"
                disabled
                checked={values.gender === 'male'}
                onChange={(e) =>
                  setValues({ ...values, gender: e.target.value })
                }
              />{' '}
              Male
            </label>
            <label>
              <input
                type="radio"
                name="gender"
                value="Female"
                disabled
                checked={values.gender === 'female'}
                onChange={(e) =>
                  setValues({ ...values, gender: e.target.value })
                }
              />{' '}
              Female
            </label>
          </RadioGroup>
          {errors.gender && <ErrorText>{errors.gender}</ErrorText>}
        </FormGroup>
      </FormRow>

      <FormRow>
        <FormGroup>
          <Label>
            Mobile No.<span>*</span>
          </Label>
          <Input
            value={values.mobile}
            onChange={(e) => setValues({ ...values, mobile: e.target.value })}
            error={errors.mobile}
          />
          {errors.mobile && <ErrorText>{errors.mobile}</ErrorText>}
        </FormGroup>
        <FormGroup>
          <Label>
            Email<span>*</span>
          </Label>
          <Input
            value={values.email}
            onChange={(e) => setValues({ ...values, email: e.target.value })}
            error={errors.email}
          />
          {errors.email && <ErrorText>{errors.email}</ErrorText>}
        </FormGroup>
      </FormRow>

      <FormRow>
        <FormGroup>
          <Label>
            Address 1<span>*</span>
          </Label>
          <Input
            value={values.address1}
            onChange={(e) => setValues({ ...values, address1: e.target.value })}
            error={errors.address1}
          />
          {errors.address1 && <ErrorText>{errors.address1}</ErrorText>}
        </FormGroup>
        <FormGroup>
          <Label>
            Address 2
          </Label>
          <Input
            value={values.address2}
            onChange={(e) => setValues({ ...values, address2: e.target.value })}
            error={errors.address2}
          />
          {errors.address2 && <ErrorText>{errors.address2}</ErrorText>}
        </FormGroup>
      </FormRow>

      <FormRow>
        <FormGroup>
          <Label>
            State<span>*</span>
          </Label>
          <Input value={values.state} disabled />
        </FormGroup>
        <FormGroup>
          <Label>
            City<span>*</span>
          </Label>
          <Input
            value={values.city}
            disabled
            onChange={(e) => setValues({ ...values, city: e.target.value })}
            error={errors.city}
          />
          {errors.city && <ErrorText>{errors.city}</ErrorText>}
        </FormGroup>
      </FormRow>

      <FormGroup>
        <Label>
          Pincode<span>*</span>
        </Label>
        <Input
          list="pincodeOptions"
          value={values.pincode}
          onChange={(e) => setValues({ ...values, pincode: e.target.value })}
          error={errors.pincode}
        />
        <datalist id="pincodeOptions">
          {values.pincodeOptions?.map((po, index) => (
            <option key={index} value={po.pinCode}>
              {po.pinCode} - {po.name}, {po.district}
            </option>
          ))}
        </datalist>
        {errors.pincode && <ErrorText>{errors.pincode}</ErrorText>}
        {loading && (
          <span style={{ fontSize: '12px', color: '#999' }}>
            Loading pincode...
          </span>
        )}
      </FormGroup>

      <FormRow>
        <FormGroup>
          <Label>
            PAN Number<span>*</span>
          </Label>
          <Input value={values.pan} onChange={(e) => setValues({ ...values, pan: e.target.value })} />  
        </FormGroup>
      </FormRow>

      <FormRow>
        <FormGroup>
          <Label>
            Nominee Full Name<span>*</span>
          </Label>
          <Input
            value={values.NomineeName}
            disabled
            onChange={(e) =>
              setValues({ ...values, NomineeName: e.target.value })
            }
            error={errors.NomineeName} // Corrected field name
          />
          {errors.NomineeName && <ErrorText>{errors.NomineeName}</ErrorText>}
        </FormGroup>
        <FormGroup>
          <Label>
            Nominee Relation<span>*</span>
          </Label>
          <Input
            value={values.NomineeRelation}
            disabled
            onChange={(e) =>
              setValues({ ...values, NomineeRelation: e.target.value })
            }
            error={errors.NomineeRelation} // Corrected field name
          />
          {errors.NomineeRelation && (
            <ErrorText>{errors.NomineeRelation}</ErrorText>
          )}
        </FormGroup>
      </FormRow>

      <FormRow>
        <FormGroup>
          <Label>
            Nominee Date of Birth<span>*</span>
          </Label>
          <Input
            value={values.NomineeDob}
            disabled
            onChange={(e) =>
              setValues({ ...values, NomineeDob: e.target.value })
            }
            error={errors.NomineeDob} // Corrected field name
          />
          {errors.NomineeDob && <ErrorText>{errors.NomineeDob}</ErrorText>}
        </FormGroup>
      </FormRow>

      <ButtonBack onClick={onBack}>Back</ButtonBack>
      <Button onClick={onContinue}>Continue</Button>
    </Section>
  );
};

export default ProposerDetails;
